import { Component, OnInit, Input } from '@angular/core';
import { TaskProcessObject } from 'src/app/models/orders/order-details-process/process-details/process-task.model';
import { Router, NavigationExtras } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-process-errors',
  templateUrl: './process-errors.component.html',
  styleUrls: ['./process-errors.component.css']
})
export class ProcessErrorsComponent implements OnInit {

  @Input() task: TaskProcessObject;
  appData: any;

  constructor(private router: Router, private appService: AppService) {
  }

  ngOnInit() {
    this.appData = this.appService.settings;
  }

  public openErrorTask() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        id: this.task.getId(),
      }
    };
    window.open(`${this.appData.baseUrl}${this.appData.basePath}/provision/tasks/detail?id=${this.task.getId()}`, '_blank');
  }

}
